import { isCodeIssueType, Issue } from "@/domain/issue"
import { isKodemRisk } from "@/domain/vulnerability"
import { Language } from "@/icons"
import { HighProfileIcon } from "@/molecules/HighProfileIcon"
import {
  DescriptionVulnerableCodeIssue,
  IssueDetails
} from "@/molecules/IssueDetails"
import { LinkRisk } from "@/molecules/LinkRisk"

import styles from "./IssueTitleCell.module.scss"

import type { TFunction } from "@/hooks/useTranslation"

export const IssueTitleCell = ({
  t,
  setRecord
}: {
  t: TFunction
  setRecord?: (issue: Issue) => void
}) =>
  function IssueTitleCellComponent(
    _: string,
    { key, ...props }: Issue & { key?: string }
  ) {
    const { id, riskId, packageName, language, cwe, issueType, filePath } =
      props
    const isVulnerableCode = isCodeIssueType(issueType)
    const cweDescription = cwe?.description
    const isCweExists = !!cweDescription
    const title = cweDescription || (isKodemRisk(riskId) ? riskId : null)

    return (
      <IssueDetails
        issueId={id}
        t={t}
        title={
          title ? (
            title
          ) : (
            <LinkRisk cve={riskId} classes={{ text: styles.description }} />
          )
        }
        description={
          isVulnerableCode ? (
            <DescriptionVulnerableCodeIssue
              language={language}
              filePath={filePath || ""}
            />
          ) : (
            <>
              <HighProfileIcon
                record={props}
                className={styles.highProfileIcon}
                t={t}
              />
              {isCweExists && (
                <LinkRisk classes={{ text: styles.details }} cve={riskId} />
              )}
              {isCweExists && " on "}
              <Language
                secondary
                className={styles.languageIcon}
                language={language}
              />
              <span>{packageName}</span>
            </>
          )
        }
        {...props}
        onAddLabel={() => setRecord?.(props)}
      />
    )
  }
